import { render, staticRenderFns } from "./subsidyInfo.vue?vue&type=template&id=52b33ce4&"
import script from "./subsidyInfo.vue?vue&type=script&lang=js&"
export * from "./subsidyInfo.vue?vue&type=script&lang=js&"
import style0 from "./subsidyInfo.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports